export default __webpack_public_path__ + "static/media/Workload.2abe368f.png";